module.exports = __webpack_public_path__ + "img/06-AppDNF-02.a91c18d6.png";